<template>
  <footer class="bg-black-footer py-10 pb-5 px-5 grid grid-cols-3">
    <div class="text-gray-text col-span-3 md:col-span-2 mb-5">
      <p class="mb-2 text-sm">&copy; Copyright 2022 Xarcade - Cost-Effective Video Game Distribution. All rights reserved.</p>
      <div class="mt-4 text-gray-text flex items-center text-sm">
        Developed on
        <img :src="require('@/assets/images/sirius-chain.png')" class="pt-2 px-3 relative -top-1 h-10">
      </div>
    </div>
    <div class="mb-2 col-span-3 md:col-span-1">
      <div class="social">
        <h5 class="text-gray-text text-lg">FOLLOW US ON:</h5>
        <ul class="flex m-0 p-0 pt-2 text-gray-text" style="grid-gap: 15px">
          <li><a href="https://www.facebook.com/xarcadeofficial" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-facebook"></span></a></li>
          <li><a href="https://twitter.com/xarcadeofficial" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-twitter"></span></a></li>
          <li><a href="https://www.instagram.com/xarcadeofficial/" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-instagram"></span></a></li>
          <li><a href="https://www.reddit.com/r/xarcade/" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-reddit"></span></a></li>
          <li><a href="https://xarcadeofficial.medium.com/" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-medium"></span></a></li>
          <li><a href="https://discord.com/invite/FpHBF5N" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-discord"></span></a></li>
          <li><a href="https://t.me/xarcadeofficial" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-telegram"></span></a></li>
          <li><a href="https://www.youtube.com/channel/UC3s7Cv_N8iNor28c-ITppRQ" target="_blank" class="hover:text-gray-300 transition-all duration-300"><span class="xr-youtube"></span></a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Footer",
});
</script>

<style lang="scss" scoped>
  // @import "@/assets/scss/global.scss";
</style>
